import React from 'react';
import '../styles/Portfolio.css';

import D6Image from '../assets/D1.jpg';
import D2Image from '../assets/D2.jpg';
import D3Image from '../assets/D3.jpg';
import D4Image from '../assets/D4.jpg';
import D5Image from '../assets/D5.jpg';
import D7Image from '../assets/D7.jpg'; // Make sure this is .jpg, not .mp4

const projects = [
  {
    id: 1,
    title: 'Global Sourcing and Procurement',
    description:
      'Helping clients connect with reliable suppliers in China while ensuring high-quality and compliant products for Ethiopian markets.',
    image: D6Image, // Changed from video to image
  },
  {
    id: 2,
    title: 'Efficient Shipping and Customs Clearance',
    description:
      'We handle every logistics step from freight forwarding to customs documentation ensuring fast and secure deliveries.',
    image: D2Image, // Changed from video to image
  },
  {
    id: 3,
    title: 'End-to-End Supply Chain Management',
    description:
      'Our integrated systems enable real-time visibility and control across sourcing, shipping, and delivery operations.',
    image: D3Image, // Changed from video to image
  },
  {
    id: 4,
    title: 'Industrial Machinery Import Support',
    description:
      'Specialized in large-scale industrial equipment and machinery importation for Ethiopia\'s growing infrastructure sector.',
    image: D4Image, // Changed from video to image
  },
 {
  id: 5,
  title: 'Premium Car Deals & Quick Auto Services',
  description:
    'Offering exclusive car deals, fast auto support, and personalized vehicle solutions tailored for clients looking for reliability, speed, and comfort.',
  image: D5Image,
},
{
  id: 6,
  title: 'International Expo Participation',
  description: 'Actively participating in major international trade expos across China to showcase Ethiopian products, connect buyers with Ethiopian suppliers.',
  image: D7Image,
},
];

const Portfolio = () => {
  return (
    <div className="page portfolio-page">
      <header className="portfolio-header">
        <h1>Seamless International Trade and Logistics Services</h1>
        <p>
          Explore our standout projects that demonstrate our dedication,
          expertise, and commitment to border trade.
        </p>
      </header>

      <section className="portfolio-grid">
        {projects.map((project) => (
          <div key={project.id} className="portfolio-item">
            <div className="image-container">
              <img
                src={project.image}  // Now this matches the property name
                alt={project.title}
                loading="lazy"
              />
            </div>
            <div className="portfolio-text">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Portfolio;